'use client'

import SliderSectionTop from '@/components/SliderSectionTop'
import UsefulMatSlider from '@/components/useful-materials/UsefulMatSlider'
import { useGetAllMaterialsQuery } from '@/redux/services/materialsApi'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FooterSection = ({ page, count }) => {
    const { t } = useTranslation()
    const { data: allMaterials } = useGetAllMaterialsQuery({
        page: page,
        count: count
    })
    return (
        <section className='useful-materials__carousel'>
            <div className='container'>
                <SliderSectionTop
                    title={t('usefulMaterialsTitle')}
                    linkText={t('watchAll')}
                />
            </div>
            <div className='useful-materials__slider-limiter'>
                <UsefulMatSlider
                    scroll={605}
                    list={allMaterials?.slice(0, allMaterials.length / 2)}
                />
            </div>
            <div className='useful-materials__slider-limiter'>
                <UsefulMatSlider
                    scroll={511}
                    list={allMaterials?.slice(allMaterials.length / 2)}
                />
            </div>
        </section>
    )
}

export default FooterSection
